module.exports = __webpack_public_path__ + "static/media/36@2x.e4714fee.png";